export default __webpack_public_path__ + "public/icons/folder.png?fa9934340910a206d60ca633c7a42412";